import React from 'react';
import SidebarLogo from './SidebarLogo';
import SidebarContextSelector from './SidebarContextSelector';
import SidebarNav from './SidebarNav';
import SidebarUserMenu from './SidebarUserMenu';

// Shared Fusion sidebar column (Part A5) — the single dark rail used on
// every internal page. Composes the lockup, the config-driven nav, and
// the user chip. Rendering this everywhere (instead of each page
// hand-assembling the three parts inside its own wrapper) keeps the
// sidebar pixel-identical across the app.
//
// WIDTH: 288px (w-72), widened from the original 256px spec on 2026-08-13.
// Nav labels truncate, and at 256 "Compliance Configuration" was being cut
// off — a nav item that can't show its own name is the one thing the rail
// exists to do. Noting the change because the A5 spec quotes 256px and is
// mirrored in Quotezilla: if the two are meant to stay pixel-identical,
// that rail needs the same widening rather than this one reverting.
//
// The dark surface stays dark in the light-content app (A1): bg-sb-bg
// with an sb-line right edge. `currentInternalUser` is passed through
// (not re-fetched) so we don't add an auth round-trip per page.
export default function Sidebar({ currentInternalUser }) {
  // data-otto-sidebar marks this as THE nav rail for the Otto idle set.
  // `aside` alone is ambiguous (BriefDetail's facts rail, SupplierPortal's
  // column), and shot 03 transforms whatever it resolves — see ottoStage.js.
  return (
    // COLLAPSES TO AN ICON RAIL BELOW xl (1280px).
    //
    // 288px is a fifth of a 1440px window and nearly a third of a 1000px one,
    // and `flex-shrink-0` means it never gives — so on anything less than a
    // maximised window the content column was being squeezed until tables
    // scrolled sideways and single words wrapped one per line.
    //
    // Collapsed rather than hidden: this is an admin tool and the nav is used
    // constantly, so losing it behind a toggle costs more than it saves. The
    // icons stay, the labels go, and every row keeps a title tooltip.
    //
    // Pure CSS, deliberately. No state, no persistence, no resize listener --
    // it is correct the instant the window changes and there is nothing to get
    // out of step.
    <aside
      data-otto-sidebar
      className="w-[76px] xl:w-72 bg-sb-bg border-r border-sb-line flex flex-col flex-shrink-0 h-screen sticky top-0">
      <SidebarLogo />
      <SidebarContextSelector />
      <SidebarNav currentInternalUser={currentInternalUser} />
      <SidebarUserMenu />
    </aside>
  );
}
